export default "__VITE_ASSET__3c4e00dc__"